export default __webpack_public_path__ + "navigation-examples-custom-banner-1200-92c81a5e876c65cad97ec2dce1f726dd.webp";